<ul itemscope itemtype="https://schema.org/BreadcrumbList" class="list-breadcrumb list-clear list-inline title-s">
    <ng-container *ngFor="let breadcrumb of breadcrumbs$ | async; let last = last; let position = index; trackBy: trackByIndex">
        <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
            <a itemprop="item" *ngIf="breadcrumb?.url && !last; else noLink" (click)="navigate($event, breadcrumb.url)" [href]="breadcrumb.url">
                <span itemprop="name">{{ breadcrumb.label }}</span>
            </a>
            <ng-template #noLink>
                <span [ngClass]="{ 'c-dark-grey': last }" itemprop="name">{{ breadcrumb.label }}</span>
            </ng-template>
            <meta itemprop="position" [content]="position + 1" />
        </li>

        <li *ngIf="!last">
            <span class="mx-4">/</span>
        </li>
    </ng-container>
</ul>
